export const basicProps = {
  options: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: '请选择',
  },
  /**
   * 是否多选  multiple/single
   */
  mode: {
    type: String,
    default: 'multiple',
  },
  /**
   * 选择变化时触发
   */
  onChange: {
    type: Function,
  },
  /**
   * 展开的节点
   */
  expandedKeys: {
    type: Array,
    default: [],
  },
  /**
   * 选中的节点
   */
  value: {
    type: [Array, String],
    default: [],
  },
  /**
   * 选中的节点
   */
  defaultValue: {
    type: [Array, String],
    default: [],
  },
}
